import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './pt_translation.json';
import en from './en_translation.json';
import es from './es_translation.json';

const supportedLangs = ['pt', 'pt-BR', 'en', 'en-US', 'es', 'es-ES']; // adicoionar tambem no componente de selecao de idioma (preferencias.js) e no backend

// Verifica se existe idioma salvo no localStorage
let savedLang = localStorage.getItem('appLanguage');
const navigatorLg = navigator.language || navigator.userLanguage;

// Se não houver idioma salvo ou não for suportado, define pelo navegador ou fallback
if (!savedLang || !supportedLangs.includes(savedLang)) {
  savedLang = supportedLangs.includes(navigatorLg) ? navigatorLg : 'en';
  localStorage.setItem('appLanguage', savedLang);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt': { translation: pt },
      'pt-BR': { translation: pt },
      'en': { translation: en },
      'en-US': { translation: en },
      'es': { translation: es },
      'es-ES': { translation: es }
    },
    lng: savedLang, // sempre consistente com localStorage
    supportedLngs: supportedLangs,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;